import type { SVGProps } from "react";
import { useId } from "react";
import { cx } from "@/utils/cx";

export const EveLogo = (props: SVGProps<SVGSVGElement>) => {
    const id = useId();

    return (
        <svg
            width="147"
            height="136"
            viewBox="0 0 147 136"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            className={cx(props.className)}
        >
            <path
                d="M73.3667 0.169952C73.7604 0.170946 74.133 0.226157 74.481 0.325225C85.1902 -0.380917 96.2236 1.45866 106.689 6.18166C140.729 21.5443 155.871 61.5926 140.508 95.6328C125.146 129.673 85.0965 144.815 51.0562 129.452C28.1888 119.132 13.8505 97.6709 11.5591 74.375C11.3565 73.9962 11.207 73.5717 11.1314 73.1045L0.0522623 4.63871C-0.341745 2.20249 1.54233 -0.0059799 4.01027 4.21052e-05L73.3667 0.169952ZM22.0366 15.9659C19.5687 15.9599 17.6845 18.1692 18.0786 20.6055L26.0308 69.7461C26.1181 70.2857 26.3017 70.7686 26.5552 71.1895C27.8057 89.5629 38.873 106.671 56.8326 114.776C82.8162 126.503 113.387 114.946 125.114 88.9619C136.84 62.9784 125.282 32.4073 99.2984 20.6807C90.8176 16.8534 81.8479 15.5065 73.2046 16.3321C72.7808 16.1769 72.3158 16.0892 71.8169 16.0879L22.0366 15.9659Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                opacity="0.85"
                d="M70.9273 52.9955C71.2785 52.1062 72.6346 52.1062 72.9858 52.9955C74.2226 56.1272 76.4274 61.1238 78.7841 63.6769C81.0405 66.1212 84.874 67.8836 87.4108 68.8556C88.2766 69.1874 88.3737 70.5047 87.5562 70.9423C85.0226 72.2987 81.084 74.6336 78.7841 77.1251C76.4073 79.7 74.185 84.1708 72.9544 86.8983C72.5811 87.7257 71.332 87.7257 70.9587 86.8983C69.7281 84.1708 67.5058 79.7 65.129 77.1251C62.829 74.6336 58.8905 72.2987 56.3569 70.9423C55.5394 70.5047 55.6365 69.1874 56.5023 68.8556C59.0391 67.8836 62.8726 66.1212 65.129 63.6769C67.4857 61.1238 69.6905 56.1272 70.9273 52.9955Z"
                fill="#6EDBF1"
            />
            <path
                opacity="0.85"
                d="M88.4477 46.4921C88.6306 46.064 89.2825 46.064 89.4654 46.4921C90.0827 47.9366 91.1883 50.2534 92.3703 51.4355C93.4653 52.5304 95.3031 53.3289 96.57 53.7851C97.0179 53.9464 97.0639 54.6349 96.638 54.8476C95.3696 55.4809 93.485 56.5277 92.3703 57.6424C91.1774 58.8353 90.0623 60.9099 89.4485 62.1674C89.2553 62.563 88.6577 62.563 88.4646 62.1674C87.8508 60.9099 86.7357 58.8353 85.5428 57.6424C84.428 56.5277 82.5435 55.4809 81.2751 54.8476C80.8492 54.6349 80.8952 53.9464 81.3431 53.7851C82.61 53.3289 84.4478 52.5304 85.5428 51.4355C86.7248 50.2534 87.8304 47.9366 88.4477 46.4921Z"
                fill="#69F05C"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="26.4565"
                    y1="67.2286"
                    x2="146.957"
                    y2="76.7278"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#959292" />
                </linearGradient>
            </defs>
        </svg>
    );
};

